import { combineReducers } from '@reduxjs/toolkit'

import {
  JOB_INFO_IMAGES_REDUCER_NAME,
  JOB_INFO_REDUCER_NAME,
} from 'features/jobs/consts'
import { fetchJobInfoReducer, jobImagesReducer } from 'features/jobs/slice'

export default combineReducers({
  [JOB_INFO_REDUCER_NAME]: fetchJobInfoReducer,
  [JOB_INFO_IMAGES_REDUCER_NAME]: jobImagesReducer,
})
